import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FeedbackService } from 'src/app/notifications/feedback.service';
import { BlendEvent, SHARE_DETAILS_OPEN_STATE } from 'src/app/shared/models';
import { ShareService } from 'src/app/shared/services/share.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { IErrorCode, IShareData, ISharememberData } from 'src/sync';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { BlendService } from 'src/app/shared/services/blend.service';

@Component({
  selector: 'app-share-choose-owner',
  templateUrl: './share-choose-owner.component.html',
  styleUrls: ['./share-choose-owner.component.scss']
})
export class ShareChooseOwnerComponent implements OnInit, OnDestroy {
  @Input() public shareData: IShareData;
  @Input() public openState: number;
  @Output() openStateChange: EventEmitter<number> = new EventEmitter();

  @Input() showDialog!: boolean;
  @Output() showDialogChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  name: string = '';
  public selectedMember;
  public members = [];
  public errors: Array<IErrorCode> = [];
  public spinner: boolean;
  public isSmallScreen: boolean = false;

  private openPopup(state: number) {
    this.openStateChange.next(state);
  }
  private breakpointSubscription: Subscription;
  constructor(
    private shareService: ShareService,
    public breakpointObserver: BreakpointObserver,
    private Feedback: FeedbackService,
    private snackbarService: SnackbarService,
    private blendService: BlendService
  ) { }

  ngOnInit() {
    this.breakpointSubscription = this.breakpointObserver.observe([
      '(max-width: 599px)',
    ])
    .subscribe((state: BreakpointState) => {
      if (state.breakpoints['(max-width: 599px)']) {
        this.isSmallScreen = true;
      } else {
        this.isSmallScreen = false;
      }
      
    });  
    this.showDialog = true;
    this.name = this.shareData['name'];
    this.shareData.people.forEach(member => {
      if (!(
        member.isMe ||
        ['Waiting Signup', 'Waiting'].includes(member.status)
      )) {
        this.members.push({ value: member.email, name: member.email })
      }
    }
    );

    // If no active members, add a special menu item
    if (this.members.length === 0) {
      this.members.push({
        name: 'No active users to transfer ownership to.',
        value: null,
        disabled: true,
        subtext: 'Users must accept to join the folder to be an active user.',
      });
    }
  }

  ngOnDestroy(): void {
    if (this.breakpointSubscription) {
      this.breakpointSubscription.unsubscribe();
    }
  }

  closeDialog = (state: number = SHARE_DETAILS_OPEN_STATE.CLOSE_STATE) => {
    this.showDialog = false;
    setTimeout(() => {
      this.showDialogChange.next(state>0 ? true : false);
      this.openPopup(state)
    }, 50);
  }
  onBack = () => {
    this.closeDialog(SHARE_DETAILS_OPEN_STATE.MEMBER_LIST);
  }
  public setPermission = async (permission: 'perOWNER', sharemember: ISharememberData): Promise<string | null> => {
    this.errors = [];
    try {
      const newVal = !sharemember.permissions[permission] ? 1 : 0;
      await this.shareService.setPermission(this.shareData, permission, sharemember);
      sharemember.permissions[permission] = newVal;
      this.spinner = false;
      return null;
    } catch (err) {
      this.errors.push(err);
      this.spinner = false;
      if (typeof err === 'string') {
        return err;
      } else {
        return err.message || 'Failed to change ownership!';
      }
    }
  }
  public changeOwnership = async (sharemember: ISharememberData) => {

    const error = await this.setPermission('perOWNER', sharemember);

    this.closeDialog();
    if (!error) {
      this.blendService.track(BlendEvent.CHANGE_SHARE_OWNER)
      this.snackbarService.showMessage('success', `Ownership of ${this.name} successfully transferred.`)
      return this.Feedback.setFeedback('success', 'Ownership has been transferred successfully', 3000);
    } else {
      this.snackbarService.showMessage('critical', 'Couldn’t complete action. Try again.')
      return this.Feedback.setFeedback('error', `Failed to transfer the ownership. ${error}`, 3000);
    }
  }
  public onMemberChange = (event: any) => {
    console.log('onMemberChange',event);
    
    this.selectedMember = event.value;
  }
  onTransfer = () => {
    if (!this.selectedMember) { return; }
    this.spinner = true;
    const newOwner: ISharememberData = this.shareData.people.find((member) => this.selectedMember === member.email);
    this.changeOwnership(newOwner);
  }

}
